/**
 * window.RendiToast — generic toast/notification (Figma "Sonner").
 *
 *   RendiToast.show({
 *     message: 'Text',                       // required
 *     theme: 'inverted',                     // optional, default light popover
 *     action: { label: 'Annulla', onClick }, // optional button
 *     duration: 6000,                         // optional, 0 = stays until dismissed
 *     container: el                           // optional mount point (default: global region)
 *   }) -> { dismiss, el }
 *
 * Styling lives in rendi-toast.css. The default container is a fixed bottom-centre
 * region appended to <body>; callers can pass their own positioned container.
 */
(function () {
  'use strict';

  function globalRegion() {
    let el = document.querySelector('[data-rendi-toast-region="global"]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'rendi-toast-region';
      el.setAttribute('data-rendi-toast-region', 'global');
      document.body.appendChild(el);
    }
    return el;
  }

  function build(options) {
    const toast = document.createElement('div');
    toast.className = 'rendi-toast' + (options.theme === 'inverted' ? ' rendi-toast--inverted' : '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    const text = document.createElement('p');
    text.className = 'rendi-toast__text';
    text.textContent = options.message || '';
    toast.appendChild(text);

    if (options.action && options.action.label) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rendi-toast__action';
      btn.textContent = options.action.label;
      toast.appendChild(btn);
    }
    return toast;
  }

  window.RendiToast = {
    show: function (options) {
      options = options || {};
      const container = options.container || globalRegion();
      const toast = build(options);
      container.appendChild(toast);

      let dismissTimer;
      function dismiss() {
        clearTimeout(dismissTimer);
        toast.classList.remove('rendi-toast--in');
        setTimeout(function () {
          toast.remove();
        }, 220);
      }

      const btn = toast.querySelector('.rendi-toast__action');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (options.action && typeof options.action.onClick === 'function') {
            options.action.onClick();
          }
          dismiss();
        });
      }

      void toast.offsetWidth; // reflow so the enter transition runs from hidden
      toast.classList.add('rendi-toast--in');

      const duration = options.duration == null ? 6000 : options.duration;
      if (duration > 0) dismissTimer = setTimeout(dismiss, duration);

      return { dismiss: dismiss, el: toast };
    }
  };
})();
